import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../api";
import FileUploader from "./FileUploader";
import CommonCalendar from "./CommonCalendar";
import AddressAutocomplete from "./AddressAutocomplete";
import { format, parse } from "date-fns";
import { toggleShowModalDriverLicenseDetails } from "../Store/modalStatusSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const DrivingLicense = ({ setDrivingLicenseLoader = () => {}, setActiveModal = () => {}, setLicenseDetails = [], setStripeModalZindex = () => {} }) => {
  const dispatch = useDispatch();
  const token = sessionStorage.getItem("AccessToken");

  const [mailingAddressCheckbox, setMailingAddressCheckbox] = useState(false);

  const [drivingLicenseDocument, setDrivingLicenseDocument] = useState({
    frontPage: "",
    backPage: "",
    drivingLicenseNumber: "",
    expiryDate: "",
  });

  //this state is using for AddressAutocomplete component
  const [addressDetails, setAddressDetails] = useState({
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    countryCode: "",
    secondAddressline: "",
  });

  const [licenseDetailsCheckbox, setLicenseDetailsCheckbox] = useState(false);
  const [showConditions, setShowConditions] = useState(false);

  const [drivingLicenseErrors, setDrivingLicenseErrors] = useState({
    drivingLicenseNumber: "",
  });

  const [errors, setErrors] = useState({
    country: "",
    state: "",
    city: "",
    zipCode: "",
    address: "",
  });

  const getLicenseDetails = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}licensedetail/getCurrentUserLicenseDetails`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLicenseDetails(response?.data);
    } catch (error) {
      // setLicenseError(
      //   `Error fetching in License due to ${error?.response?.data?.message}`
      // );
    }
  };

  const handleDateSelect = (selectedDate) => {
    setDrivingLicenseDocument((prevValues) => ({
      ...prevValues,
      expiryDate: format(
        parse(selectedDate, "MM/dd/yyyy", new Date()),
        "yyyy-MM-dd"
      ),
    }));
  };

  const postDrivingLicenseData = async () => {
    // Create FormData instance
    const formData = new FormData();

    // Append addressDetails data to FormData (replace with actual fields)
    formData.append("licenseFrontSide", drivingLicenseDocument?.frontPage);
    formData.append("licenseBacksideSide", drivingLicenseDocument?.backPage);
    formData.append(
      "licenseNumber",
      drivingLicenseDocument?.drivingLicenseNumber
    );
    formData.append("expiration", drivingLicenseDocument?.expiryDate);
    formData.append("issuingCountryCode", addressDetails.countryCode);
    formData.append("issuingState", addressDetails.state);
    formData.append("issuingCityZipCode", addressDetails.zipCode);
    formData.append("addressLine1", addressDetails.address);
    formData.append("addressLine2", addressDetails.secondAddressline);
    formData.append("country", addressDetails.country);
    formData.append("city", addressDetails.city);
    formData.append("isMailingAddress", mailingAddressCheckbox);

    try {
      setStripeModalZindex(false)
      setDrivingLicenseLoader(true);
      // Send the POST request with FormData and token header
      const response = await axios.post(
        `${BASE_URL}licensedetail/createLicenseDetail`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in Authorization header
          },
        }
      );
      dispatch(toggleShowModalDriverLicenseDetails(false));
      // toast.success(" Driver License details updated Successfully.");
      setActiveModal("");
      // Handle the response if needed
      setDrivingLicenseLoader(false);
      getLicenseDetails();
      return response.data;
    } catch (error) {
      setDrivingLicenseLoader(false);
      console.error(
        "Error posting driving license data:",
        error?.response?.data?.message
      );
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <div>
      <div className={`px-2 py-2 mb-2 br8 bg23 d-flex justify-content-between align-items-center`}>
        {/* <div className="p-1 m-1 fontAntarctica fontSize17">Driver License</div> */}
        <div className="d-flex align-items-center">
          <div className="">
            {/* Related to strip will enable in improvements */}
            {/* <DesktopCustomModal
                      isModalOpen={activeModal.includes("DrivingLicenseModal")}
                      closeModal={() => closeModal("DrivingLicenseModal")}
                      closeOnOutsideClick={true}
                      modalCenter={true}
                      modalId="driverLicenseModal"
                      modalClassHeight="modalHeightDrivingLicense"
                      modalButton={
                        licenseDetails?.data === null ? (
                          <div
                            onClick={() => {
                              openModal("DrivingLicenseModal");
                              getStripeLinkToverify();
                            }}
                          >
                            Verify Now
                          </div>
                        ) : (
                          "Verified"
                        )
                      }
                    >
                      <StripeAndManualDrivingLicense
                        stripeStatusCode={stripeStatusCode}
                        setStripeStatusCode={setStripeStatusCode}
                        stripeStatusResponse={stripeStatusResponse}
                        closeModal={closeModal}
                        verificationStripeURL={verificationStripeURL}
                      />
                     
                     
                    </DesktopCustomModal> */}
          
             <div className="d-flex  flex-column">
              <div className="mb-2 d-flex flex-column flex-lg-row justify-content-between align-items-center cursorPointer">
                <div className="m-1 cursor w-100">
                  <FileUploader
                    onFileChange={(file) => {
                      setDrivingLicenseDocument((prevValues) => ({
                        ...prevValues,
                        frontPage: file,
                      }));
                    }}
                    handleDeleteFile={() => {
                      setDrivingLicenseDocument((prevValues) => ({
                        ...prevValues,
                        frontPage: "",
                      }));
                    }}
                    label="Front Page"
                    fileTextMessage="Drag & drop some files here, or click to select files"
                  />
                </div>
                <div className="m-1 cursor w-100">
                  <FileUploader
                    onFileChange={(file) => {
                      setDrivingLicenseDocument((prevValues) => ({
                        ...prevValues,
                        backPage: file,
                      }));
                    }}
                    handleDeleteFile={() => {
                      setDrivingLicenseDocument((prevValues) => ({
                        ...prevValues,
                        backPage: "",
                      }));
                    }}
                    label="Back Page"
                    fileTextMessage="Drag & drop some files here, or click to select files"
                  />
                </div>
              </div>
              <div>
                <form>
                  <div
                    onClick={() => {
                      if (showConditions) {
                        setShowConditions(false);
                      }
                    }}
                  >
                    <div className="mb-3">
                      <input
                        id="DrivingLicenseNumber"
                        placeholder="Enter Driver License Number"
                        type="text"
                        maxLength={20}
                        className="form-control border3B3936 supportFormFocus p-2 bg-transparent outlineNone text-white"
                        value={drivingLicenseDocument?.drivingLicenseNumber}
                        onChange={(e) => {
                          setDrivingLicenseDocument((prevValues) => ({
                            ...prevValues,
                            drivingLicenseNumber: e.target.value,
                          }));
                          const regex = /^[a-zA-Z0-9]{1,20}$/; // Only allow alphabets and numbers
                          //const regex = /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{1,20}$/;
                          if (!regex.test(e.target.value)) {
                            setDrivingLicenseErrors((prev) => ({
                              ...prev,
                              drivingLicenseNumber: "Invalid driver license",
                            }));
                          } else {
                            setDrivingLicenseErrors((prev) => ({
                              ...prev,
                              drivingLicenseNumber: "",
                            })); // Clear error if valid
                          }
                        }}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setDrivingLicenseErrors((prev) => ({
                              ...prev,
                              drivingLicenseNumber:
                                "Driver license is required",
                            }));
                          }
                        }}
                      />
                      {drivingLicenseErrors?.drivingLicenseNumber && (
                        <div className="text-danger mt-2">
                          {drivingLicenseErrors?.drivingLicenseNumber}
                        </div>
                      )}
                    </div>

                    <div className="mb-3 position-relative">
                      <CommonCalendar
                        onDateSelect={handleDateSelect}
                        handleBlur={() => {}}
                        defaultViewDate={new Date()}
                        minDate={new Date()}
                        maxDate=""
                        placeholder="Enter Expiry Date"
                        value={drivingLicenseDocument?.expiryDate}
                      />
                    </div>

                    <AddressAutocomplete
                      addressDetails={addressDetails}
                      setAddressDetails={setAddressDetails}
                      errors={errors}
                      setErrors={setErrors}
                    />
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <input
                      type="checkbox"
                      id="mailingAddress"
                      className="me-2"
                      checked={mailingAddressCheckbox}
                      onChange={() =>
                        setMailingAddressCheckbox(!mailingAddressCheckbox)
                      }
                    />
                    <label htmlFor="mailingAddress" className="text-white">
                      Use this address as my Mailing Address
                    </label>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <input
                      type="checkbox"
                      id="licenseDetails"
                      className="me-2"
                      checked={licenseDetailsCheckbox}
                      onChange={() =>
                        setLicenseDetailsCheckbox(!licenseDetailsCheckbox)
                      }
                    />
                    <div
                    //onMouseEnter={() => setShowConditions(true)} // Show content on hover
                    //onMouseLeave={() => setShowConditions(false)} // Hide content when mouse leaves
                    >
                      <label
                        htmlFor="licenseDetails"
                        className="text-white px-1"
                      >
                        We will use your license details to perform a driver and
                        criminal background check. For details{" "}
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            setShowConditions(!showConditions);
                          }}
                          className="cursorPointer fontColorCE1"
                        >
                          Read More
                        </span>
                      </label>
                      {showConditions && (
                        <div
                          onClick={() => setShowConditions(!showConditions)}
                          className="col-md-12"
                        >
                          <div className="row">
                            <div
                              className="col-md-12 customizedScrollBar bg23 p-2 px-4 borderRadius8"
                              style={{
                                height: "300px",
                                width: "400px",
                                overflow: "auto",
                                position: "absolute",
                                top: "68%",
                                left: "1%",
                                border: "1px solid grey",
                              }}
                            >
                              <p>
                                Joulez may need to request a consumer report,
                                drivers record report, or other background check
                                in order to approve your rental application. By
                                checking the box, you authorize Joulez and its
                                designated agents and representatives to conduct
                                a comprehensive review of your records. By
                                checking the box, you indicate that you
                                understand the scope of the consumer report may
                                include, but is not limited to: criminal
                                history, including records from any criminal
                                justice agency in any or all federal, state, or
                                county jurisdictions; motor vehicle records,
                                including traffic citations and registration;
                                and any other public record that might be
                                relevant to determining your risk as a vehicle
                                renter.
                              </p>
                              <p>
                                If you are a California resident, you have the
                                right to receive the report Joulez reviews. By
                                sending us an e-mail at
                                reservations@drivejoulez.com, you can request to
                                receive a copy of the report Joulez reviews.
                                Upon receipt of the report, Joulez will provide
                                a copy of the report to you within three
                                business days to the e-mail address you have
                                associated with this rental.
                              </p>
                              <p>
                                By withholding your permission, no records will
                                be reviewed and your rental reservation will not
                                be processed further.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    className={`signInButton bgCE1 text-white w-100 ${
                      drivingLicenseErrors?.drivingLicenseNumber === "" &&
                      errors?.country === "" &&
                      errors?.address === "" &&
                      errors?.city === "" &&
                      errors?.state === "" &&
                      errors?.zipCode === "" &&
                      licenseDetailsCheckbox &&
                      addressDetails?.address !== "" &&
                      addressDetails?.city !== "" &&
                      addressDetails?.country !== "" &&
                      // addressDetails?.countryCode !== "" &&
                      addressDetails?.state !== "" &&
                      addressDetails?.zipCode !== "" &&
                      drivingLicenseDocument?.frontPage !== "" &&
                      drivingLicenseDocument?.backPage !== "" &&
                      drivingLicenseDocument?.drivingLicenseNumber !== "" &&
                      drivingLicenseDocument?.expiryDate !== ""
                        ? ""
                        : "disabled-class"
                    }`}
                    onClick={postDrivingLicenseData}
                  >
                    Proceed
                  </button>
                </form>
              </div>
              </div>
          </div>
          {/* {licenseDetails?.data !== null && (
            <div className="mx-1 d-block d-lg-none">Verified</div>
          )} */}
          {/* {licenseDetails?.data === null ? (
            <Overlay
              dataBsTitle="Please upload the License to confirm the booking"
              direction="bottom"
            >
              <img
                className="m-1"
                src={licenseDetails?.data === null ? infoIcon : latestGreenTick}
                alt="infoIcon"
              />
            </Overlay>
          ) : (
            <img className="mx-1" src={latestGreenTick} alt="latestGreenTick" />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default DrivingLicense;
